import useSWR from 'swr';
import type { LiveUiFull } from '@/types';
import type { LiveStageSnapshot } from '@/types/live';
import {
  NamesTicker,
  OVERLAY_TRANSPARENCY,
  SponsorStrip,
  TrackBadge,
  Wordmark,
} from '../components/overlay';

const STAGE_SLUG = 'main';
const POLL_MS = 500;

const fetcher = async (url: string): Promise<LiveStageSnapshot> => {
  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) throw new Error(`live fetch failed: ${res.status}`);
  return res.json();
};

// GET /:eventSlug/live/ui/full — the OBS browser source that composites over the video
// feed: wordmark, the currently-presenting track and the presenting team's names, kept
// current by polling /api/:eventSlug/stages/main/live twice a second (PORTING.md U4).
export default function Full({ eventSlug, overlay }: LiveUiFull) {
  const { data } = useSWR<LiveStageSnapshot>(
    `/api/${eventSlug}/stages/${STAGE_SLUG}/live`,
    fetcher,
    {
      refreshInterval: POLL_MS,
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      keepPreviousData: true,
    },
  );

  const trackName = data?.presenting?.track?.name ?? null;
  const members = data?.presenting?.team?.members ?? [];

  return (
    <>
      <style>{OVERLAY_TRANSPARENCY}</style>
      <div className="fixed inset-0 overflow-hidden">
        <Wordmark overlay={overlay} />
        {trackName && <TrackBadge overlay={overlay} name={trackName} />}
        <div className="absolute inset-x-0 bottom-0">
          {members.length > 0 && <NamesTicker members={members} />}
          <SponsorStrip overlay={overlay} />
        </div>
      </div>
    </>
  );
}
